module.exports = __webpack_public_path__ + "img/thumbnail.67cbb80d.jpg";